[
  {
    "url": "/_next/static/chunks/turbopack-f9f327487c65e1a4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-f73f6ec9792c6af6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-f4e746e969cf41bb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-ee9fc8c8c33bea85.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-ee5163a6614b0fd5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-d5291bc256fd2fb0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-d0bdcd594e332c7c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-c64ed605c487ae08.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-bde4fc944909bc98.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-bd8f510e9968e7d7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-a2da4ad17b12801b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-a1098bf2fe3fe860.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-996928524e7e41c9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-7c6afc462ce2e529.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-6d6468ae6daa000b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-5b69fa620d739912.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-53b529c246c66d98.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-47c454ab886d7dde.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-4518c34e90144cd3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-36d3be1e24fa3ab5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2d1517773e63b569.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-210cb569f8e066a0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1c3a443506d4c450.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-12783859950af471.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/fe65c2e6b2065309.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/fb04574417f959b3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/fa131f3fc3b01f69.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/f7f5ee35a7d45de0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/f373bcabb7d2691e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/f06b4d1cd8884eb6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/ec59e0c5369e8242.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/eabbc926a96e4729.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/e376b434f11e3b44.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/e0529b9fceeccb0a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/dbdac595fe41aefb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/da974f4f723ad5c3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/da09ebc35fc63ddd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/da031213c6bd9f16.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/d9b1b527458a0988.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/d60b4c204ecec27f.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/d5d9c0f4285b50d1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/d29b2a19aa5134ef.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/ccc2ed8bb5ff2411.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/c96e299d53767111.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/c08a0149f13f6038.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/bbdca06d661c42ce.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/bb9f85b627f44ebf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/b7d1f0f6a58e1a61.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/b5d397f335c52468.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/b2e33e4205f82757.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/b00b7a44bf388a34.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/af07a35788a8eebd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/ab9d261c6b9f3cdf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/a6dad97d9634a72d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/a235ab9f2ecd3c3e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/9c9bc731146aa4c3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/98411b73c7d11880.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/9834ea6e9d7f5e4e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/96e6d7de2ca8932b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/9687c38040097372.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/94d08c9e02c01f6b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/93a00b1b13a0f5b3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/8f7895b5461b270b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/8d265e192467e4a7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/8b82023838ad5831.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/8a2f5585be18a35e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/88a088697a560f81.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/87ec1248765d660b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/86ec94359e6dcd24.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/84d539596d4ab464.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/8336b456208dadd9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/807d89b3c3196357.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/7ff2f1a7bcf67297.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/79ab402d5d002343.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/78df49f31e05a9eb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/781e17800eb09291.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/7525b174aad859e4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/75004d1e6e7ecbaf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/74ea49c3067f4b27.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/74c5f56026d87676.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/6cf1b9db27bc6003.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/6c462b75e959a9fb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/690016c3b64cebb1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/67aabc64599eed8b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/65a91ac5ae2df2c8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/6295aa64d011397b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/616493fea5b084b9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5ede80f71881f519.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5d4ce52716361537.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5bbca41c2ba5e74b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5af61f318dc4ece0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/59a9482c1ce01bd6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/57557aac1cde7450.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5472d4550f9d01e6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5251e73af57fd795.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/4e784ad89ac035d2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/4b701dbfe584f89d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/46bb66ebcf0e96ed.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/456e5a32e53d652e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/44e2bd625aefb876.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/435787bd751af7bf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/4209e319b20dcc48.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3dc4edff6a7425f2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3a40e5f3762903b5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3116dbe9a7d5c4b0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2da4d61e2ebfc3af.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/284fc9a3012de34e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/27bb0e669a783de5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/272ce34bd063aa1c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/270d931aea8b5757.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/26f7d135010cdbf0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/225591376dcc83c9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/217c40f871c20786.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/21187b0829c4d3e5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1c14c052912a8fc5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/18dd179ab56d1718.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1551faf2bb0ed24e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/12984c4fd654e679.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/106a94478e937589.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0e40c643fa9f6004.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/070cb8f6a1dcbc83.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06b1a3dd621665e1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/067a8307964e06ec.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/03728fa6fe2fee29.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0369bff147bee6be.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0251e39f7f1ee59a.js",
    "revision": null
  },
  {
    "url": "/_next/static/LoqwgPuwkBfZNbRatzqpp/_ssgManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/LoqwgPuwkBfZNbRatzqpp/_clientMiddlewareManifest.json",
    "revision": null
  },
  {
    "url": "/_next/static/LoqwgPuwkBfZNbRatzqpp/_buildManifest.js",
    "revision": null
  },
  {
    "url": "/manifest.json",
    "revision": "d2e96cf41e641815ec612edc05d5873c"
  },
  {
    "url": "/favicon.ico",
    "revision": "bdbc317416fb8fe9f412f0cbb0c6d1ab"
  },
  {
    "url": "/images/trophy.png",
    "revision": "be8919896a7da9cce954fa11d6583559"
  },
  {
    "url": "/images/super-trophy.png",
    "revision": "cf2a1b1e45279298a6a9eb07a4a3a9b9"
  },
  {
    "url": "/images/rf4_logo_lite.png",
    "revision": "f27817468d44c5ee3eef18b79f87da45"
  },
  {
    "url": "/images/rf4_logo.png",
    "revision": "91e111a2e7afd27146a3a26f912a0615"
  },
  {
    "url": "/images/marker-shadow.png",
    "revision": "44a526eed258222515aa21eaffd14a96"
  },
  {
    "url": "/images/marker-icon.png",
    "revision": "2273e3d8ad9264b7daa5bdbf8e6b47f8"
  },
  {
    "url": "/images/marker-icon-2x.png",
    "revision": "401d815dc206b8dc1b17cd0e37695975"
  },
  {
    "url": "/images/layers.png",
    "revision": "a6137456ed160d7606981aa57c559898"
  },
  {
    "url": "/images/layers-2x.png",
    "revision": "4f0283c6ce28e888000e978e537a6a56"
  },
  {
    "url": "/images/it_IT.png",
    "revision": "ad489ca177d082a1b854d66462b6b9cb"
  },
  {
    "url": "/images/favicon_blured.png",
    "revision": "2c7f18735037a5a77dea4c6c3c016df4"
  },
  {
    "url": "/images/favicon.png",
    "revision": "7d5cedbf9509a5e0e47a1651674c5902"
  },
  {
    "url": "/images/en_US.png",
    "revision": "decf409ce6a075d8246e125e63348da0"
  },
  {
    "url": "/images/donate.png",
    "revision": "5f97d0505de9a0d8bd9e71b71ba50fcd"
  },
  {
    "url": "/icons/icon-512x512.png",
    "revision": "6d843f610d1a05f759bf313d604822f0"
  },
  {
    "url": "/icons/icon-192x192.png",
    "revision": "f9cae6d41e0e76f3b7766260fe9d4b87"
  },
  {
    "url": "/icons/favicon-32x32.png",
    "revision": "bbef84051f1ca1d7dfc4c2d2b35a0d1a"
  },
  {
    "url": "/icons/favicon-16x16.png",
    "revision": "9687a2f10248b547046b697214c3138f"
  },
  {
    "url": "/icons/apple-touch-icon.png",
    "revision": "ee05f9aa11b87b009745333fc28f1e40"
  }
]